import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux'
import { Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { gridSpacing } from '../store/constant';
import LineChart from './components/Chart/LineChart';
import TotalCard from './components/TotalCard';
import axios from "../components/axios";

const style = {
    padding: "10px",
    paddingTop: "80px"
};

const Dashboard = () => {
    const navigate = useNavigate();
    const [isLoading, setLoading] = useState(true);
    const [totalTest, setTotalTest] = useState(0);
    const [weekData, setWeekData] = useState([]);
    const [weekDate, setWeekDate] = useState([]);
    const [monthData, setMonthData] = useState([]);
    const [monthDate, setMonthDate] = useState([]);
    const customization = useSelector((state) => state.customization);
    const userInfo = JSON.parse(localStorage.getItem("qbarn.user"));
    const lineWidth = [ 5, 5 ];
    const lineDash = [0, 0];
    const series2 = [];

    useEffect(() => {
        const getData = async () => {
          axios.post("/data/v1/dashboard-data", null, {withCredentials: true})
          .then(response => {
            if (response.data.message === "success") {
                setTotalTest(response.data.total_tests)
                let weekItem = {name: 'Automation Tests', data: response.data.week_data}
                let weekList = []
                weekList.push(weekItem);
                setWeekData(weekList)
                setWeekDate(response.data.week_date)
                let monthItem = {name: 'Automation Tests', data: response.data.month_data}
                let monthList = []
                monthList.push(monthItem);
                setMonthData(monthList)
                setMonthDate(response.data.month_date)
            }else{
                alert(response.data.message);
            }
          })
          .catch(function(err){
            if (!err.response){
                alert(err);
            }else{
                if (err.response.status === 401){
                  navigate("/");
                }else{
                  console.log('error.response.status: ', err.response.status);
                  console.log('error.response.status: ', err.response.data.message);
                  alert(err.response.data.message);
                }
            }
          })
        };
        getData()
        setLoading(false);
    }, [navigate]);

    return (

    	<div style={style}>
        <Grid container spacing={gridSpacing}>

        {!customization.login &&
            (<Grid container spacing={0} direction="column" alignItems="center">
                <Typography variant="h6">Please login!</Typography>
            </Grid>)}

            <Grid item xs={12}>
                <Grid container spacing={gridSpacing}>
                    <Grid item lg={4} md={6} sm={6} xs={12}>
                    {customization.login && userInfo !== null && userInfo['role'] === 'admin' && (<TotalCard isLoading={isLoading} totalTest={totalTest}/>)}
                    </Grid>
                    <Grid item lg={4} md={6} sm={6} xs={12}>
                    </Grid>
                    <Grid item lg={4} md={12} sm={12} xs={12}>
                        <Grid container spacing={gridSpacing}>
                            <Grid item sm={6} xs={12} md={6} lg={12}>
                            </Grid>
                            <Grid item sm={6} xs={12} md={6} lg={12}>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <Grid container spacing={gridSpacing}>
                    <Grid item xs={12} md={8}>
                        {customization.login && userInfo !== null && userInfo['role'] === 'admin' && (<LineChart isLoading={isLoading} categories={weekDate} series={weekData} decimal={0} title='Weeekly Automation Tests' lineWidth={lineWidth} lineDash={lineDash} title2='' series2={series2}/>)}
                    </Grid>
                    <Grid item xs={12} md={4}>
                    </Grid>
                    <Grid item xs={12} md={8}>
                        {customization.login && userInfo !== null && userInfo['role'] === 'admin' && (<LineChart isLoading={isLoading} categories={monthDate} series={monthData} decimal={0} title='Monthly Automation Tests' lineWidth={lineWidth} lineDash={lineDash}  title2='' series2={series2}/>)}
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
        </div>
    );
};

export default Dashboard;